<template>
  <v-ons-list
    class="spot-detail"
    modifier="noborder"
  >
    <template v-if="Object.keys(destinationSpot).length">
      <!-- NOTE: リスト表示と共通の概要表示 -->
      <spot-Outline :spot="destinationSpot" />

      <!-- NOTE: キーワード -->
      <v-ons-list-item modifier="longdivider">
        <div>
          <div class="spot-detail-title">キーワード</div>
            <span class="separater--comma">
              {{ destinationSpot.keywords }}
            </span>
            <span
              v-for="(tag) in destinationSpot.tags"
              class="separater--comma"
            >{{ tag.name }}</span>
        </div>
      </v-ons-list-item>

      <!-- NOTE: 人が多い時間帯 -->
      <v-ons-list-item modifier="longdivider">
        <div class="center time-chart">
          <v-ons-row
            vertical-align="center"
            class="spot-detail-title"
          >
            <v-ons-col>
              人が多い時間帯：
            </v-ons-col>
            <v-ons-col>
              <v-ons-select
                v-model="selectedWeek"
                @change="changeSelectedWeek"
              >
                <option
                  v-for="(day, key) in week"
                  :key="key"
                  :value="day.value"
                >
                  {{ day.name }}
                </option>
              </v-ons-select>
            </v-ons-col>
          </v-ons-row>
          <swiper
            :options="swiperOption"
            ref="congestionSwiper"
            @slideChange="slideChange"
          >
            <swiper-slide
              v-for="(day, key) in week"
              :key="key"
              :style="slideSize"

            >
              <spot-congestion-chart
                :chart-id="`congestion-${day.value}`"
                :height="chartSize.height"
                :width="chartSize.width"
                :day-name="key"
              />
            </swiper-slide>
          </swiper>
          <div class="swiper-pagination" />
        </div>
      </v-ons-list-item>

      <!-- NOTE: スポット情報 -->
      <spot-environment />

    </template>
  </v-ons-list>
</template>


<script>
import config from '@/config.js';
import spotOutline from '@/components/map/partials/destination_outline/spot.vue';
import spotEnvironment from './spot_environment.vue';
import spotCongestionChart from './spot_congestion_chart.vue';
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  components: {
    spotOutline,
    spotEnvironment,
    spotCongestionChart,
    swiper,
    swiperSlide
  },
  data() {
    return {
      week: config.week,
      selectedWeek: 0,
      congestionSwiper: null,
    };
  },
  computed: {
    destinationSpot: ({ $store }) => $store.state.searchResult.destination,
    chartSize() {
      return {
        height: 104,
        width: 521,
      };
    },
    slideSize() {
      return {
        height: `${this.chartSize.height}px`,
        width: `${this.chartSize.width}px`,
      };
    },
    swiperOption: (vm) => ({
      initialSlide: vm.selectedWeek,
      height: vm.chartSize.height,
      width: vm.chartSize.width,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
    }),
  },
  created() {
    this.getDayOfWeek();
  },
  mounted() {
    this.initCongestionSwiper();
  },
  methods: {
    changeSelectedWeek() {
      this.congestionSwiper.slideTo(this.selectedWeek);
    },
    getDayOfWeek() {
      const now = new Date();
      this.selectedWeek = now.getDay();
    },
    initCongestionSwiper() {
      this.congestionSwiper = this.$refs.congestionSwiper.swiper;
    },
    slideChange(e) {
      this.selectedWeek = this.congestionSwiper.activeIndex;
    },
  },
};
</script>

<style scoped lang="scss">
.spot-detail {
  font-size: 12px;
  &-title {
    margin-bottom: 10px;
    /deep/ {
      ons-col {
        flex: 0 0 auto;
        width: auto;
      }
      .select-input {
        margin-left: 5px;
        font-size: inherit;
        color: inherit;
      }
    }
  }
}
.time-chart {
  width: 100%;
}
.swiper-pagination {
  position: relative;
  width: 100%;
  text-align: center;
  /deep/ .swiper-pagination-bullet {
    margin: 0 3px;
  }
}
</style>



// WEBPACK FOOTER //
// spot.vue?4e4eef24